// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 9830 ? "ProductBadgeApp" : chunkId) + ".js?id=" + {"4945":"862da1d36011914c","9063":"13eaecefcef0fac6","9830":"cd2cb451294d3227"}[chunkId] + "";
};